import { api } from 'src/api/axios';
import type { Application } from './application-reviews';

export const applicationsService = {
  get: async (id: string | number): Promise<Application> => {
    const response = await api.get<Application>(`/applications/${id}`);
    return response.data;
  },

  getPayloadHtml: async (id: string | number): Promise<string> => {
    const response = await api.get(`/applications/${id}/payload/html`, {
      responseType: 'text' as any,
    });
    return response.data as string;
  },

  getPayloadPdf: async (id: string | number): Promise<Blob> => {
    const response = await api.get(`/applications/${id}/payload/pdf`, {
      responseType: 'blob',
    });
    return response.data as Blob;
  },

  getContractPdf: async (id: string | number): Promise<Blob> => {
    const response = await api.get(`/applications/${id}/contract/pdf`, {
      responseType: 'blob',
    });
    return response.data as Blob;
  },

  getContractZip: async (id: string | number): Promise<Blob> => {
    const response = await api.get(`/applications/${id}/contract/zip`, {
      responseType: 'blob',
    });
    return response.data as Blob;
  },
};
